// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBfO7bdODawyyc-lWMFdGPmr45NRT-8Crg",
  authDomain: "focus-muscle.firebaseapp.com",
  databaseURL: "https://focus-muscle-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "focus-muscle",
  storageBucket: "focus-muscle.appspot.com",
  messagingSenderId: "711344347468",
  appId: "1:711344347468:web:5f4787bc31eefaeabc57e9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
export default db